import { render, staticRenderFns } from "./Reclamation.vue?vue&type=template&id=6062f241&scoped=true"
import script from "./Reclamation.vue?vue&type=script&lang=js"
export * from "./Reclamation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6062f241",
  null
  
)

export default component.exports